import React from 'react'
import { FC } from 'react'
import { Header } from './header'
import '../assets/fonts/fonts.css'
import { Footer } from './footer'
import { Helmet } from 'react-helmet'

interface LayoutProps {
  title: string
  activePage: string
}

export const Layout: FC<LayoutProps> = ({ title, activePage, children }) => (
  <>
    <Helmet title={title} />
    <Header activePage={activePage} />
    <main>{children}</main>
    <Footer />
  </>
)
